import HeroWithDownload from "../components/organisms/common/HeroWithDownload";
import CutoutFeaturedImage from "../components/organisms/common/CutoutFeaturedImage";
import CtaWithChecklist from "../components/organisms/common/CtaWithChecklist";
import Theme from "../components/Theme";
import Masonry from "../components/organisms/common/Masonry";
import FAQ from "../components/organisms/common/FAQ";
import FeaturedImage from "../components/organisms/common/FeaturedImage";
import People from "../components/organisms/common/People";
import WideCTA from "../components/organisms/common/WideCTA";
import ResponsiveImage from "../components/atoms/image/ResponsiveImage";
import Schema from "../components/organisms/common/Schema";
import AppStorage from "../components/AppStorage";
import TpWidget from "../components/atoms/document/TpWidget";

export async function getStaticProps(ctx) {
  let allData = {};
  const { locale } = ctx;
  // Page Route
  const route = "ipad";

  // Fetch data for respective pages
  const headerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/header.json`
  );

  const footerResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/common/footer.json`
  );

  const marketingResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/marketing.json`
  );

  const contentResponse = await fetch(
    `${process.env.JSON_PATH}/${locale}/others/${route}/content.json`
  );

  // Catch Error
  if (marketingResponse.status === 404 || contentResponse.status === 404) {
    return {
      notFound: true,
    };
  }

  // Convert
  allData.header = await headerResponse.json();
  allData.footer = await footerResponse.json();
  allData.marketing = await marketingResponse.json();
  allData.content = await contentResponse.json();

  // Wrap
  const header = {
    header: allData.header,
  };
  const footer = {
    footer: allData.footer,
  };
  // Combine all data
  const data = await {
    ...header,
    ...footer,
    ...allData.marketing,
    ...allData.content,
  };

  // Return to the component
  return {
    props: {
      data,
    },
  };
}

export default function Page({ data, nonce }) {
  const { seo, header, footer, content } = data;
  return (
    <Theme
      header={header}
      footer={footer}
      seo={seo}
      nonce={nonce}
      className="page-with-faq landing-page landing-page-ipad"
    >
      <AppStorage pageName="Others - ipad" />
      <HeroWithDownload data={content.hero} />
      <CutoutFeaturedImage
        data={content.cutoutFeaturedImage}
        className="lg:pb-10 md:pb-7"
      />
      <CtaWithChecklist
        data={content.ctaWithChecklist}
        className="lg:pb-20 md:pb-10"
      />
      <Masonry
        data={content.masonry}
        className="lg:mb-20 md:mb-10 bg-offset-top"
      />
      <section>
        {content.featuredImageSections.map((item, index) => {
          return (
            <FeaturedImage
              data={item}
              key={index}
              imageAlign={item.image.align}
            />
          );
        })}
      </section>
      <CtaLight data={content.ctaLight} />
      {content.hasOwnProperty("faqs") && (
        <>
          <FAQ
            data={content.faqs}
            className="bg-offset-top lg:pb-15 md:pb-10"
          />
          <Schema data={content.faqs.list} />
        </>
      )}
      <People />
      <WideCTA data={content.wideCTA} />
      <TpWidget />
    </Theme>
  );
}

export const CtaLight = ({ data }) => {
  const appMode = process.env.APP_MODE;
  const link = data?.cta?.href?.[appMode] || data?.cta?.href;
  return (
    <section className="bg-offset-bottom lg:pt-10 md:pt-5 md:pb-10 cta-w-image-section bg-light">
      <div className="container cta-contrast has-image br-8 lg:d-fx premium-bg-cta md:d-fx">
        <article className="lg:maxw-md lg:mr-5 md:pr-2.5 md:pb-5 md:pl-2.5 md:text-center md:mt-2">
          <h2
            className="text-lg text-black lg:mb-5 md:mb-2.5"
            dangerouslySetInnerHTML={{ __html: data.title }}
          />
          {data.cta.hasOwnProperty("hasDownload") ? (
            <>
              <a
                href={data.cta.appstoreBtn.href}
                className="cta-light-app-store lg:mr-5"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  loading="lazy"
                  src={data.cta.appstoreBtn.image.src}
                  alt={data.cta.appstoreBtn.image.alt}
                  width="157"
                  height="48"
                />
              </a>
            </>
          ) : (
            <a href={link} className="btn-primary">
              <span>{data.cta.text}</span>
            </a>
          )}
        </article>
        <ResponsiveImage
          loading="lazy"
          alt={data.image.alt}
          src={data.image.src}
          dpi={data.image.prefixes.dpi}
          mobile={data.image.prefixes.mobile}
          imgClass="lg:maxw-lg"
        />
      </div>
    </section>
  );
};
